import {inject} from "@angular/core";
import {ActivatedRoute, Data} from "@angular/router";
import {EMPTY, merge, Observable, of, switchMap} from "rxjs";

function getTopParent(route: ActivatedRoute): ActivatedRoute {
    let current = route;
    while (current.parent != null) {
        current = current.parent;
    }
    return current;
}

export function getNestedRouteData<T>(retriever: (data: Data) => (T | null), route: ActivatedRoute = getTopParent(inject(ActivatedRoute))): Observable<T> {
    return route.data.pipe(
        switchMap((data) => {
            const result = retriever(data);
            if (result != null) {
                return of(result);
            }
            if (route.children.length === 0) return EMPTY;
            return merge(...route.children.map(c => getNestedRouteData(retriever, c)));
        }),
    );
}